import APIManager from 'modules/common/apiManager';
const mAPI = new APIManager();
export const callerId = (search, limit = 50, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let searchQuery = '';
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/phone-number?limit=${limit}&page_no=${page_no}${searchQuery}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id || data.phone_number,
              provider : data.provider || "",
              label: data.phone_number
            });
          });
          resolve(options);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};
export const Team = (search, limit = 300, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let searchQuery = '';
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `team/list?limit=${limit}&filterVariable=status&filterValue=true&filterVariableValueType=boolean&orderBy=create_at&order=DESC&page_no=${page_no}${searchQuery}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id || data.name,
              label: data.name
            });
          });
          resolve(options);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};
export const Queue = (search, limit = 50, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let searchQuery = '';
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/queue?limit=${limit}&orderBy=create_at&order=DESC&page_no=${page_no}${searchQuery}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id || data.name,
              label: data.name
            });
          });
          resolve(options);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};
export const Flow = (search, limit = 50, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let searchQuery = '';
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/flow?limit=${limit}&orderBy=create_at&order=DESC&page_no=${page_no}${searchQuery}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id || data.name,
              label: data.name
            });
          });
          resolve(options);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};
export const Contact = (search, limit = 50, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let searchQuery = '';
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `contact/contact-list/list?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id || data.name,
              label: data.name,
              fields: data.fields || [],
            });
          });
          resolve(options);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};
export const campaignRemanningCount = campaignId => {
  return new Promise((resolve, reject) => {
    var that = this;
    mAPI.sendGetAPI(
      `campaign/contact-list/info/${campaignId}`,
      data => {
        if (data && data.counts) {
          // for (const key in list) {
          //   if (list[key]) {
          //     count += list[key].underProcessing || 0;
          //   }
          // }
          resolve(data.counts);
        } else {
          resolve(0);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(-1);
        } else {
          resolve(-1);
        }
      }
    );
  });
};
export const getSounds = (search, limit = 50, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/sound?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "url": tData.url,
              "filename": tData.filename || "",
              "id": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};
export const getCampaign = (search, limit = 50, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `campaign?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};
export const getTeam = (search, limit = 300, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `team/list?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getDespose = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `despose?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getUser = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `user?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getStickyAgent = (search, limit = 300, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `sticky-group/list?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getBreak = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/break?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};
export const StickyGroup = (search, limit = 300, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let searchQuery = '';
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `sticky-group/list?limit=${limit}&orderBy=create_at&order=DESC&page_no=${page_no}${searchQuery}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id || data.name,
              label: data.name
            });
          });
          resolve(options);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};

export const getSMSProvider = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/sms-provider?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getSMSTemplate = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/sms-template?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getEmailProvider = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/email-provider?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};
export const getTags = () => {
  return new Promise((resolve, reject) => {
    var that = this;
    mAPI.sendGetAPI(
      `despose`,
      data => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          resolve(data.data);
        }
      },
      (error, data) => {
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};

export const getEmailTemplate = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/email-template?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};

export const getProvider = (search, limit = 20, page_no = 1) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `setting/telephony?limit=${limit}&page_no=${page_no}${searchQuery}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          data.data.map( tData => {
            result.push({
              "name": tData.name,
              "id": tData._id,
              "_id": tData._id,
              "label": tData.name,
              "value": tData._id,
            })
          });
          resolve(result);
        } else {
          resolve(result);
        }
      },
      (error, data) => {
        if (data) {
          resolve(result);
        } else {
          resolve(result);
        }
      }
    );
  });
};
export const getUserList = ( search, limit = 20, page_no = 1, filterKey="", filterValue="", filterType="" ) => {
  return new Promise((resolve, reject) => {
    var that = this;
    let result = [];
    let searchQuery  = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    mAPI.sendGetAPI(
      `user?limit=${limit}&page_no=${page_no}${searchQuery}&filterKey=${filterKey}&filterValue=${filterValue}&filterType=${filterType}&orderBy=create_at&order=DESC`,
      data => {
        if (data && data.data) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      },
      (error, data) => {
        if (data) {
          resolve([]);
        } else {
          resolve([]);
        }
      }
    );
  });
};


// WEBPACK FOOTER //
// src/modules/common/utils/api.js